import type { FolderUploadDialogRequest } from './folderUploadDialogRequest';
import { requestDialog } from './requestDialog';

export function showFolderUploadDialog(req: FolderUploadDialogRequest) {
  requestDialog(req, () => import('@mimir/web/components/Common/Dialogs/dialogs/ItemAndFolderUploadDialog.vue'));
}
